import PropTypes from 'prop-types'

/**
 * Copy Link Input component
 * 
 * @param {object} props
 * @param {string} props.id - component ID
 * @param {string} props.placeholder - placeholder text for input
 * @param {string} props.label - label text that appears above the input
 * @param {boolean} props.required - true if input is required, false otherwise
 * @param {number} props.charLimit - maximum number of characters that can be input
 * @param {string} props.value - the current value held in the input (used with useState)
 * @param {Function} props.setValue - function for setting some state to the current input value
 */
const CopyLink = ({ id, placeholder, label, required, charLimit, value, setValue }) => {

    const copyToClipboard = () => {
        navigator.clipboard.writeText(value)
            .then(() => {
                alert('Link copied!');
            })
            .catch((err) => {
                console.error('Failed to copy text: ', err);
            });
    };

    return (
        <div className="copy-link-center">
            {label && (
                <label className="input-label" htmlFor={id}>
                    {required ? `${label} *` : label}
                </label>
            )}
            <div className="inner">
                <input
                    type="text"
                    id={id}
                    name={id}
                    placeholder={placeholder}
                    maxLength={charLimit}
                    required={required}
                    value={value}
                    readOnly
                    onChange={setValue}
                    style={{ flex: 1, padding: '0.5rem', textAlign: 'center' }}
                />
                <button
                    type="button"
                    onClick={copyToClipboard}
                    style={{ marginLeft: '8px', padding: '0.5rem 1rem' }}
                >
                    Copy Link
                </button>
            </div>
        </div>
    );
};

CopyLink.propTypes = {
    id: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    label: PropTypes.string,
    required: PropTypes.bool,
    charLimit: PropTypes.number,
    value: PropTypes.string,
    setValue: PropTypes.func,
};

export default CopyLink;
